<template>
  <div class="mb-4">
    <button 
      class="btn bg-utel-v2-secondary text-primary" 
      @click="$emit('back')"
    >
      <i class="fa fa-arrow-left" aria-hidden="true"></i>
      <strong> Regresar</strong>
    </button>
    
    <h3 class="mt-3">
      <strong style="color:#1A0054">Detalle de estudiante</strong>
    </h3>
  </div>
</template>

<script>
export default {
  name: 'StudentDetailHeader',
  
  emits: ['back']
}
</script>